import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${(props) => props.theme.typography.textsFont};
    background-color: ${({ theme }) =>
      theme.colors.background}; // Apply the theme's background color
  }

  h1, h2, h3, h4, h5, h6{
    font-family: ${(props) => props.theme.typography.headFont};
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

`;
